
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/surveys",
      function () {
        return require("private-next-pages/qmee/surveys.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/surveys"])
      });
    }
  